import styled from 'styled-components';

import { Tag } from '../Tag';

const StyledTagDiscount = styled(Tag)`
	color: #fff;
	background-color: #ff3e3e;
	filter: none !important;
`;

const StyledTagNew = styled(Tag)`
	color: #000;
	background-color: #fff;
`;

const StyledTagOnlyCase = styled(Tag)`
	color: #ffffff;
	background-color: #2d70da;
`;

export { StyledTagDiscount, StyledTagNew, StyledTagOnlyCase };
